module.exports = __webpack_public_path__ + "img/nav-btn.f047a713.png";